
export function isFlaggedNumberOfCarts(item: { orderdQuantity?: any; brokerMaterialNumber?: any; }) {

    // this may need to do a filter for is the string is contained instead of just a index of on the entire list.


    return [
        '1227516',
        '1591929',
        '000000000000042689' // test one
    ].indexOf(item.brokerMaterialNumber) > -1;
}

export function get_number_of_trays_per_cart(item: { orderdQuantity?: any; brokerMaterialNumber?: any; }, count: number) {

    let divisor = 75;
    // list of species that count as 100
    const list = [
        '1227516',
        '1591929'
    ];

    // if in list set divider to 50
    if ( list.indexOf(item.brokerMaterialNumber) > -1 ){
        divisor = 50;
    }

    // divide by divider
    let res = count / divisor;

    // return ceiling.
    return res
    // return Math.ceil(res);
}

export const EACH_LOOKUP_TABLE: {[id: string]: number} = {
    '144': 140,
    '288': 280,
    '512': 500,
    '338': 325
}

export const DAYS_OF_WEEK = ['Sunday', 'Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];